<template id="datepicker">
  <div>
    <div class="ui-datepicker"
         @keyup.left="prev('d', true)"
         @keyup.right="next('d', true)"
         @keyup.up="prev('w', true)"
         @keyup.down="next('w', true)"
         @blur="blur"
         tabindex="1">

      <div class="ui-datepicker-calendar" v-if="visible">

        <div class="heading">
          <button class="left" @click.prevent.stop="prev()"></button>
          <div class="currentMonth">{{ currentMonth }}</div>
          <button class="right" @click.prevent.stop="next()"></button>
        </div>
        {{selectedMonth}}

        <div class="calendar">
          <div class="weekdays">
            <div v-for="day in weekDays" class="weekday">
              {{ day }}
            </div>
          </div>
          <div class="month">
            <div v-for="(value, key) in calendarMonth"
                 class="week"
            >
              <div v-for="(value, key) in value"
                   class="day"
                   @click="selection(value)"
                   :class="{
                    isToday: isToday(value),
                    isSelected: isSelected(value) ,
                    isPadding: !isCurrentMonth(value)
                   }">
                {{value.format('DD')}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  // window['moment-range'].extendMoment(moment);


  import Moment from 'moment';
  import { extendMoment } from 'moment-range';

  const moment = extendMoment(Moment);

  export default {
    data(){
      return{
        selectedMonth: "",
        visible: true,
        selected: moment()
      }
    },
  props: {
      start: {
        type: String,
        default: moment().format('YYYY-MM-DD')
      },
      startFormat: {
        type: String,
        default: 'YYYY-MM-DD'
      }
    },
    created() {
    //console.log('sdsdsds')
      },
    computed: {
      currentMonth () {
        return this.date().format('MMMM, YYYY')
      },
      weekDays () {
        var date = moment().startOf('week').isoWeekday(1);
        var days = [];
        for (var i = 0; i < 7; i++) {
          days.push(date.format('ddd'))
          date.add('d', 1);
        }
        return days;
      },
      months(){
        return moment.monthsShort();
      },
      calendarMonth () {
        // iso week - starts on monday (set this to dynamic local in future)
        var start = this.date().startOf('month').startOf('isoWeek');
        var end  = this.date().endOf('month').endOf('isoWeek');
        var range = moment.range(start, end);
        var daysList  = [];


        for (var days of range.by('days')) {
          // console.log(days.format('DD'));
          daysList.push(days);
        }
        // create array
        var month = new Array(5);

        // Create empty data array form rows & columns
        for (var row = 0; row < 5; row ++){
          month[row] = new Array(7);
        }
        // Populate data in empty array
        var dayIndexCount = 0
        for ( var row = 0; row < 5; row++){
          for ( var column = 0; column < 7; column++){
            month[row][column] = daysList[dayIndexCount]
            dayIndexCount++;
          }
        }

        return month;
      },
    },
    methods: {
      // start date
      date () {
        return moment(this.start, this.startFormat);
      },
      next (type = 'M', select = false) {
        // Type is M from Month
        var m = this.date().add(1, type)
        // Start is the first day of the week in the month
        // startFormat is the prop that defines the date dormat (yyyymmdd)
        this.start = m.format(this.startFormat);
        // if selected true select date
        if( select ) this.selected = m;
      },
      prev (type = 'M',select = false) {
        var m = this.date().subtract(1, type)
        this.start = m.format(this.startFormat);
        if( select ) this.selected = m;
      },
      selection (day) {
        this.selected = day;
        this.start = day;
        document.activeElement.blur();


        var startDate = moment(day).weekday(1);
        var endDate = moment(day).weekday(7);

      //  console.log('Start Date:' + startDate.format('MM/DD/YYYY'));
      //  console.log('End Date:' + endDate.format('MM/DD/YYYY'));

        // this.$emit('clicked-show-detail', product);
        var dateData=[
          {"startDate":startDate},
          {"endDate":endDate}
        ];
         this.$emit('clicked-show-detail', dateData)
      },
      isToday (day) {
        return day.isSame( moment(), 'day' );
      },
      isCurrentMonth (day) {
        return day.isSame( this.start, 'month' )
      },
      isSelected (day) {
        return day.isSame( this.selected, 'day' )
      },
      blur () {
        console.log(arguments, blur);
      }
    }
  }


</script>

<style>
  .ui-datepicker {
 /*   background-color: #5b666a;
    width: 229px;
    border-radius: 2px;
    padding: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);*/
    background-color: #00779c;
    width: 229px;
    border-radius: 2px;
    padding: 10px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
    position: absolute;
    z-index: 5;
  }
  .ui-datepicker .ui-datepicker-calendar .heading {
    display: flex;
    justify-content: space-between;
  }
  .ui-datepicker .ui-datepicker-calendar .heading button {
    cursor: pointer;
    padding: 0;
    border-radius: 2px;
    background-color: #00779c;
    border: none;
  }
  .currentMonth{
    color: white;
  }
  .ui-datepicker .ui-datepicker-calendar .heading button:after {
    font-family: "Material Icons";
    color: #fff;
    font-size: 18px;
  }
  .ui-datepicker .ui-datepicker-calendar .heading button.left:after {
    content: "<";
  }
  .ui-datepicker .ui-datepicker-calendar .heading button.right:after {
    content: ">";
  }
  .ui-datepicker .ui-datepicker-calendar .calendar {
    text-align: center;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .weekdays {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .month .week {
    display: flex;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .month .week .day {
    color: #fff;
    padding: 5px 0;
    font-size: 14px;
    width: 100%;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .month .week .day.isToday {
    font-weight: 700;
    position: relative;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .month .week .day.isToday:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 3px;
    right: 3px;
    height: 4px;
    border-radius: 3px;
    background-color: #23a96e;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .month .week .day.isSelected {
    background-color: #829298;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .month .week .day.isPadding {
    color: #b2b2b2;
  }
  .ui-datepicker .ui-datepicker-calendar .calendar .month .week:hover {
    background-color: #829298;
  }

</style>


